import { render, staticRenderFns } from "./editstockinfo.vue?vue&type=template&id=2d3b53ac"
import script from "./editstockinfo.vue?vue&type=script&lang=js"
export * from "./editstockinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports